import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

type Props = {
  children: ReactNode;
  redirectTo?: string;
};

const DoctorProfileApprovedRoute = ({
  children,
  redirectTo = '/doctor/profile',
}: Props) => {
  const { isAuthenticated, isLoading, user, getRoleBasedRedirect } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-linear-to-br from-[#F8F7EC] to-[#E8F1D1] flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-[#7E8D4C] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#6b6358]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== 'doctor') {
    return (
      <Navigate
        to={getRoleBasedRedirect(user?.role, user?.active_profile_type)}
        replace
      />
    );
  }

  const isApproved = user?.doctorProfile?.status === 'approved';
  if (!isApproved) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default DoctorProfileApprovedRoute;
